<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Mi Tarjeta MasterCard</b-card-header>
      <b-card-body>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-12 text-center">
            <img src="@/assets/appmastersoon.png" />
          </div>
          <div class="col-md-12 text-center">
            <base-button type="success" @click="muyPronto">Muy pronto</base-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import notificationHelpers from "@/helpers/notificationHelpers";
export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    muyPronto() {
       notificationHelpers.showSuccess('Gracias por tu interes', 'Muy pronto vas a poder solicitar tu tarjeta', this)
    }
  }
};
</script>
